import clsx from "clsx";

type TagVariant = "default" | "success" | "error" | "disabled";

type TagProps = {
    variant?: TagVariant;
    className?: string;
    children: React.ReactNode;
};

const Tag = ({ variant = "default", className, children }: TagProps) => {
    return (
        <div
            className={clsx(
                "h-6 flex items-center px-3 font-semibold text-xs rounded-3xl justify-center text-ellipsis overflow-hidden whitespace-nowrap",
                variant === "default" && "bg-surface-dark text-surface-light",
                variant === "success" && "bg-soft-green-80",
                variant === "error" && "bg-red-40 text-surface-light",
                variant === "disabled" && "bg-gray-300 text-gray-400",
                className
            )}
        >
            {children}
        </div>
    );
};

export default Tag;
